import React, { useEffect, useState } from "react";
import { Typography } from "@mhome/ui";
import { SensorOpenIcon, SensorClosedIcon } from "./icon/contact-sensor-icons";

const ContactSensorDetail1Widget = ({ widget, onValueUpdate }) => {
  const [value, setValue] = useState(null);

  useEffect(() => {
    if (widget?.items?.$w1) {
      const currentValue = widget.items.$w1.value;
      setValue(
        currentValue === "" || currentValue === null ? "close" : currentValue
      );
    }
  }, [widget]);

  const getStatusText = () => {
    if (!value) return "close";
    return value;
  };

  const getContactIcon = () => {
    return value === "open" ? (
      <SensorOpenIcon style={{ fontSize: "1.5rem", color: "white" }} />
    ) : (
      <SensorClosedIcon style={{ fontSize: "1.5rem", color: "white" }} />
    );
  };

  return (
    <div className="w-full flex flex-col gap-4">
      {/* Contact Sensor Status Card */}
      <div
        className="rounded-2xl px-3 py-1.5 flex items-center justify-between transition-colors duration-300"
        style={{
          height: "40px",
          backgroundColor: "hsl(var(--primary))",
          opacity: value === "open" ? 1 : 0.2,
        }}
      >
        <Typography className="text-white font-bold capitalize">
          {getStatusText()}
        </Typography>
        <div className="h-8 aspect-square flex items-center justify-center flex-shrink-0">
          {getContactIcon()}
        </div>
      </div>
    </div>
  );
};

export default ContactSensorDetail1Widget;
